export default {
  error404: {
    heading: 'Oops, Sorry!',
    notFound: "The survey you were looking for doesn't exist or has been moved."
  }
};